import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import OptionGroup from '@components/OptionGroup'
import ButtonOption from '@components/OptionGroup/ButtonOption'

const StatusFilter = ({ type, items, staticData, ...props }) => {
  let options = items
  switch (type) {
    case 'project':
      options = Object.values(staticData.CONST.PROJECT_STATUSES)
      break
    case 'contract':
      options = Object.values(staticData.CONST.CONTRACT_STATUSES)
      break
    default:
      break
  }

  const itemToString = item => {
    let statusNames
    switch (type) {
      case 'project':
        statusNames = staticData.names.projectStatuses
        break
      case 'contract':
        const { EXPIRING_SOON } = staticData.CONST.CONTRACT_STATUSES
        if (item === EXPIRING_SOON) return 'Expiring'
        statusNames = staticData.names.contractStatuses
        break
      default:
        return item && item
    }

    return item && statusNames[item]
  }

  return (
    <OptionGroup
      items={options}
      itemToString={itemToString}
      className='status-filter'
      renderItem={({ item, className, ...props }) => (
        <React.Fragment key={item.toString()}>
          <ButtonOption
            {...props}
            item={item}
            className={`${className} ${itemToString(item)}`}
          />
        </React.Fragment>
      )}
      {...props}
    />
  )
}

StatusFilter.propTypes = {
  type: PropTypes.string,
  items: PropTypes.array,
  itemToString: PropTypes.func,
  staticData: PropTypes.object
}

export default inject('staticData')(observer(StatusFilter))
